import { render } from "./RequiresAttentionOrders.vue?vue&type=template&id=679165e5"
import script from "./RequiresAttentionOrders.vue?vue&type=script&lang=js"
export * from "./RequiresAttentionOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/RequiresAttentionOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "679165e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('679165e5', __exports__)) {
    console.log('reload')
    api.reload('679165e5', __exports__)
  }
  
  module.hot.accept("./RequiresAttentionOrders.vue?vue&type=template&id=679165e5", () => {
    console.log('re-render')
    api.rerender('679165e5', render)
  })

}


export default __exports__